const Colors = {
  blue: "#6c91bf",
}

export default Colors
